<template>
  <div style="display: flex; flex-direction: column; justify-content: center">
    <div style="display: flex; justify-content: space-between; padding-top: 24px; padding-bottom: 24px">
      <div style="color: black">Học sinh: {{ item.name }}</div>
      <div style="color: black">
        {{
          item.code_short
            ? `Mã hồ sơ: ${item.code_short} / Số báo danh: ${item.examCode}`
            : `Số báo danh: ${item.examCode}`
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  },
  computed: {},
  methods: {},
  mounted() {
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  }
}
</script>
